<template>
    <div class="site-manager-credential">
        <div class="row">
            <div class="col col-sm-10">
                <p>
                    <b>Resident: </b>
                    <a v-if="credential.legacyAdminResident" :href="this.appUrl + '/residents/' + credential.legacyAdminResident.id">
                        {{ credential.legacyAdminResident.first_name + " " + credential.legacyAdminResident.last_name }}
                    </a>
                    <span v-else> -</span>
                    <br>
                    <b>Email:</b> {{ credentialDisplayEmail }}<br>
                    <b>Service Activation:</b> {{ credentialDisplayActivationDate }}<br>
                    <b>Service Deactivation:</b> {{ credentialDisplayDeactivationDate }}<br>
                    <b>Status:</b>
                    <span v-if="credentialDisplayStatus === 'Active'" style="color: green;">Active</span>
                    <span v-else-if="credentialDisplayStatus === 'Suspended'" style="color: red;">Suspended</span>
                    <span v-else>{{ credentialDisplayStatus }}</span>
                    <a v-if="canSuspend" href="javascript://void(0)" @click="confirmSuspend"><br>Suspend Network Access</a>
                    <a v-if="credentialDisplayStatus === 'Suspended'" href="javascript://void(0)" @click="confirmUnsuspend"><br>Unsuspend Network Access</a>
                </p>
            </div>
            <div class="col col-sm-2">
                <a class="pull-right" href="javascript://void(0)" @click="confirmEditCredential">Edit</a>
                <br><br>
                <a class="pull-right" href="javascript://void(0)" @click="confirmPurgeAndRecreate">Reset</a>
            </div>
        </div>

        <span v-if="isScheduled">Send Network Invite Email (Invite scheduled...)</span>
        <a v-else href="javascript://void(0)" @click="confirmInviteEmail">Send Network Invite Email</a>
        <br>
        <span v-if="isPending">Send PSK Reset Email (Pending invite...)</span>
        <a v-else href="javascript://void(0)" @click="confirmPskReset">Send PSK Reset Email</a>
        <button type="button" class="btn btn-sm btn-warning pull-right" style="margin-right: 10px;"
                @click="confirmTerminateCredential"
                :disabled="loading">
            <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
        <br>
        <hr>
        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <div>
                    <header>
                        <h4 v-if="this.modalType === this.MODAL_EDIT">Edit Credential</h4>
                        <h4 v-else>Are you sure?</h4>
                        <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                    </header>
                    <div v-if="this.modalType === this.MODAL_RESEND_INVITE">
                        <p>
                            Network invite email will be sent to: <b>{{ credentialDisplayEmail }}</b>
                        </p>
                        <button class="btn btn-sm btn-info" @click="sendInviteEmail">Send</button>
                    </div>
                    <div v-else-if="this.modalType === this.MODAL_PSK_RESET">
                        <p>
                            Pre-shared key reset email will be sent to: <b>{{ credentialDisplayEmail }}</b>
                        </p>
                        <button class="btn btn-sm btn-info" @click="sendPreSharedKey">Send</button>
                    </div>
                    <div v-else-if="this.modalType === this.MODAL_TERMINATE">
                        <p>
                            Resident will lose network access
                        </p>
                        <button class="btn btn-sm btn-info" @click="terminateNetworkCredential">Terminate</button>
                    </div>
                    <div v-else-if="this.modalType === this.MODAL_SUSPEND">
                        <p>
                            Resident will temporarily lose network access
                        </p>
                        <button class="btn btn-sm btn-info" @click="suspendNetworkAccess">Suspend</button>
                    </div>
                    <div v-else-if="this.modalType === this.MODAL_PURGE_AND_RECREATE">
                        <p>
                            This should only be done for troubleshooting purposes. Resident will lose network access and will have to go to the 11os Network Credential Portal to onboard again.
                        </p>
                        <button class="btn btn-sm btn-info" @click="purgeAndRecreate">Purge and Recreate</button>
                    </div>
                    <div v-else-if="this.modalType === this.MODAL_UNSUSPEND">
                        <button class="btn btn-sm btn-info" @click="unsuspendNetworkAccess">Unsuspend</button>
                    </div>
                    <div v-else-if="this.modalType === this.MODAL_EDIT">
                        <div class="row">
                            <div class="col-sm-12 form-group">
                                <dt>Resident</dt>
                                <dd>
                                    {{ credential.legacyAdminResident.first_name + " " + credential.legacyAdminResident.last_name }}
                                </dd>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 form-group has-feedback"
                                    :class="{'has-error': this.error.email !== null}">
                                <label for="email">Email</label>
                                <input id="email"
                                        name="email"
                                        type="text"
                                        v-model="email"
                                        class="form-control">

                                <span v-show="this.error.email !== null" class="help-block">
                                    {{ this.error.email }}
                                </span>
                                <span v-if="email !== credentialDisplayEmail"><br><i>Note:</i> changing the email will delete the current credential and create a new one</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6 form-group has-feedback"
                                :class="{'has-error': this.error.activationDate !== null}">
                                <label for="activation_date">Activation Date</label>
                                <input id="activation_date"
                                        required="required"
                                        name="activation_date"
                                        type="date"
                                        v-validate="'required'"
                                        v-model="activationDate"
                                        class="form-control">

                                <span v-show="this.error.activationDate !== null" class="help-block">
                                    {{ this.error.activationDate }}
                                </span>
                            </div>

                            <div class="col-sm-6 form-group has-feedback"
                                :class="{'has-error': this.error.activationDate !== null}">
                                <label for="deactivation_date">Deactivation Date</label>
                                <input id="activation_date"
                                        name="deactivation_date"
                                        type="date"
                                        v-model="deactivationDate"
                                        class="form-control">

                                <span v-show="this.error.deactivationDate !== null" class="help-block">
                                    {{ this.error.deactivationDate }}
                                </span>
                            </div>
                        </div>
                        <br>
                        <button class="btn btn-sm btn-info" @click="updateCredential">Update</button>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    const MODAL_RESEND_INVITE = 1;
    const MODAL_PSK_RESET = 2;
    const MODAL_EDIT = 3;
    const MODAL_TERMINATE = 4;
    const MODAL_SUSPEND = 5;
    const MODAL_UNSUSPEND = 6;
    const MODAL_PURGE_AND_RECREATE = 7;

    export default {
        props: {
            modalId: {
                default(){
                    return _.uniqueId( 'modal_' );
                },
                type: String
            },
            unitId: {
                required: false,
                type: [String, null]
            },
            residentId: {
                required: false,
                type: [String, null]
            },
            appUrl: {
                required: true,
                type: String
            },
            credential: {
                required: true,
                type: Object
            },
            futureCredentialActivationDate: {
                required: false,
                type: [Date, null]
            }
        },

        data(){
            let credentialActivationDate = this.credential.activationDate.slice(0, 10);
            let credentialDeactivationDate = this.credential.deactivationDate ? this.credential.deactivationDate.slice(0, 10) : null;
            let credentialEmail = ''
            if (this.credential.resident) {
                let filteredEmail = this.credential.resident.emails.filter(e => e.id === this.credential.residentEmailId);
                if (filteredEmail.length) {
                    credentialEmail = filteredEmail[0].email;
                }
            }
            return {
                MODAL_RESEND_INVITE,
                MODAL_PSK_RESET,
                MODAL_TERMINATE,
                MODAL_EDIT,
                MODAL_SUSPEND,
                MODAL_UNSUSPEND,
                MODAL_PURGE_AND_RECREATE,
                loading: false,
                confirmation: false,
                modalType: MODAL_RESEND_INVITE,
                activationDate: credentialActivationDate,
                deactivationDate: credentialDeactivationDate,
                email: credentialEmail,
                error: {
                    activationDate: null,
                    deactivationDate: null,
                    email: null
                }
            };
        },

        computed: {
            credentialDisplayEmail() {
                let email = ' -';
                if (this.credential && this.credential.resident) {
                    let filteredEmail = this.credential.resident.emails.filter(e => e.id === this.credential.residentEmailId);
                    if (filteredEmail.length) {
                        email = filteredEmail[0].email;
                    }
                }
                return email;
            },
            credentialDisplayActivationDate() {
                let activationDate = ' -';
                if (this.credential) {
                    let date = new Date(this.credential.activationDate);
                    activationDate = date.toLocaleDateString() + ' ' + this.formatTime(date) + ' MST';
                }
                return activationDate;
            },
            credentialDisplayDeactivationDate() {
                let deactivationDate = ' -';
                if (this.credential && this.credential.deactivationDate) {
                    let date = new Date(this.credential.deactivationDate);
                    deactivationDate = date.toLocaleDateString() + ' ' + this.formatTime(date) + ' MST';
                }
                return deactivationDate;
            },
            credentialDisplayStatus() {
                let status = ' -';
                if (this.credential && this.credential.smResident) {
                    if (this.credential.smResident.status.includes('pending') && this.credential.smResident.status.includes('current')) {
                        status = 'Pending';
                    }
                    else if (this.credential.smResident.status.includes('disabled')) {
                        status = 'Suspended';
                    }
                    else if (this.credential.smResident.status.includes('current')) {
                        status = 'Active';
                    }
                    else if (!this.credential.smResident.status.includes('current')) {
                        status = 'Scheduled';
                    }
                }
                return status;
            },
            isPending() {
                return this.credential && this.credential.smResident && (this.credential.smResident.status.includes('pending') || this.credential.smResident.status.includes('scheduled'));
            },
            isScheduled() {
                return this.credential && this.credential.smResident && this.credential.smResident.status.includes('scheduled');
            },
            canSuspend() {
                return (
                    this.credential
                    && this.credential.smResident
                    && !this.credential.smResident.status.includes('pending')
                    && this.credential.smResident.status.includes('current')
                    && !this.credential.smResident.status.includes('disabled')
                );
            },
        },

        // If the resident is future, we pull the future credential,
        // If a credential exists, and we don't know if our resident is current or future,
        // We can show the credential & the email it is tied to
        // if we don't know, we pull the current active credential for the unit
        // PULL a list of ALL current or pending unit credentials
        mounted() {
        },

        methods: {
            confirmInviteEmail() {
                this.modalType = this.MODAL_RESEND_INVITE;
                this.openModal();
            },

            confirmPskReset() {
                this.modalType = this.MODAL_PSK_RESET;
                this.openModal();
            },

            confirmEditCredential() {
                this.modalType = this.MODAL_EDIT;
                this.openModal();
            },

            confirmPurgeAndRecreate() {
                this.modalType = this.MODAL_PURGE_AND_RECREATE;
                this.openModal();
            },

            confirmTerminateCredential() {
                this.modalType = this.MODAL_TERMINATE;
                this.openModal();
            },

            confirmSuspend() {
                this.modalType = this.MODAL_SUSPEND;
                this.openModal();
            },

            confirmUnsuspend() {
                this.modalType = this.MODAL_UNSUSPEND;
                this.openModal();
            },

            closeModal() {
                this.$modal.hide( this.modalId );
            },

            openModal() {
                this.$modal.show( this.modalId );
            },

            sendInviteEmail() {
                this.loading = true;
                var url = this.appUrl + '/api/tami/networkCredential/' + this.credential.id + '/invite';
                return axios.post(url)
                    .then(response => {
                        this.email = '';
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Network invite email sent successfully',
                        } );
                    } )
                    .catch(err => {
                        if (err.response.data.error) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: err.response.data.data
                            } );
                        }
                        else {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: 'Something went wrong sending invite email. Refresh the page and try again.'
                            } );
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                        this.closeModal();
                    });
            },

            sendPreSharedKey() {
                this.loading = true;
                var url = this.appUrl + '/api/tami/networkCredential/' + this.credential.id + '/pskReset';
                return axios.post(url)
                    .then(response => {
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Pre-shared key reset email sent successfully',
                        } );
                    } )
                    .catch(err => {
                        if (err.response.data.error) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: err.response.data.data
                            } );
                        }
                        else {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: 'Something went wrong sending psk reset email. Refresh the page and try again.'
                            } );
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                        this.closeModal();
                    });
            },

            suspendNetworkAccess() {
                this.loading = true;
                var url = this.appUrl + '/api/tami/networkCredential/' + this.credential.id + '/suspend';
                return axios.post(url)
                    .then(response => {
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Network Access successfully suspended',
                        } );
                        window.location.reload();
                    } )
                    .catch(err => {
                        if (err.response.data.error) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: err.response.data.data
                            } );
                        }
                        else {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: 'Something went wrong suspending network access. Refresh the page and try again.'
                            } );
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                        this.closeModal();
                    });
            },

            unsuspendNetworkAccess() {
                this.loading = true;
                var url = this.appUrl + '/api/tami/networkCredential/' + this.credential.id + '/unsuspend';
                return axios.post(url)
                    .then(response => {
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Network Access successfully unsuspended',
                        } );
                        window.location.reload();
                    } )
                    .catch(err => {
                        if (err.response.data.error) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: err.response.data.data
                            } );
                        }
                        else {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: 'Something went wrong unsuspending network access. Refresh the page and try again.'
                            } );
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                        this.closeModal();
                    });
            },

            purgeAndRecreate() {
                this.loading = true;
                var url = this.appUrl + '/api/tami/networkCredential/' + this.credential.id + '/purgeAndRecreate';
                return axios.post(url)
                    .then(response => {
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Network Credential successfully purged and recreated',
                        } );
                        window.location.reload();
                    } )
                    .catch(err => {
                        if (err.response.data.error) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: err.response.data.data
                            } );
                        }
                        else {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: 'Something went wrong purging and recreating credential. Refresh the page and try again.'
                            } );
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                        this.closeModal();
                    });
            },

            terminateNetworkCredential(id) {
                this.loading = true;
                var url = this.appUrl + '/api/tami/networkCredential/' + this.credential.id + '/terminate';
                return axios.post(url)
                    .then(response => {
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Network credential terminated successfully',
                        } );
                        window.location.reload();
                    } )
                    .catch(err => {
                        if (err.response.data.error) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: err.response.data.data
                            } );
                        }
                        else {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: 'Something went wrong terminating the network credential. Refresh the page and try again.'
                            } );
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                        this.closeModal();
                    });
            },

            updateCredential() {
                this.loading = true;

                if (!this.validateUpdateCredential()) {
                    this.loading = false;
                    return;
                }
                else {
                    this.resetErrors();
                }

                var url = this.appUrl + '/api/tami/networkCredential';
                return axios.put(url, {
                    'credentialId': this.credential.id,
                    'email': this.email,
                    'activationDate': this.activationDate,
                    'deactivationDate': this.deactivationDate
                })
                    .then(response => {
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Network Credential Updated',
                        } );
                        window.location.reload();
                    })
                    .catch(err => {
                        if (err.response.data.error) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: err.response.data.data
                            } );
                        }
                        else {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: 'Something went wrong updating network credential. Refresh the page and try again.'
                            } );
                        }
                    })
                    .finally((res) => {
                        this.loading = false;
                        this.closeModal();
                    });
            },

            // Helper functions / Computed values / etc
            formatTime(date) {
                let hours = date.getHours();
                let minutes = date.getMinutes();
                let ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12;
                minutes = minutes.toString().padStart(2, '0');
                let strTime = hours + ':' + minutes + ampm;
                return strTime;
            },

            // Validation / UI Feedback
            validateUpdateCredential() {
                let succeed = true;
                this.resetErrors();

                // Check valid email
                if (!this.email) {
                    this.error.email = 'Invalid email';
                    succeed = false;
                }

                // Check valid activation date
                if (this.futureCredentialActivationDate) {
                    let activation = new Date(this.activationDate + "T14:00:00.000Z");
                    activation.setHours(6);
                    let deactivation = new Date(this.deactivationDate + "T14:00:00.000Z");
                    deactivation.setHours(6);
                    let maxDate = new Date(this.futureCredentialActivationDate.getTime())
                    maxDate = maxDate.setHours(4);
                    if (activation > this.futureCredentialActivationDate) {
                        this.error.activationDate = 'Activation conflicts with a scheduled credential';
                        succeed = false;
                    }
                    if (deactivation > this.futureCredentialActivationDate) {
                        this.error.deactivationDate = 'Deactivation conflicts with a scheduled credential';
                        succeed = false;
                    }
                }

                // let existingActivation = new Date(this.credential.activationDate);
                // let activation = new Date(this.activationDate + "T14:00:00.000Z");
                // let today = new Date();
                // today.setHours(1);
                // if (activation < today && activation < existingActivation) {
                //     this.error.activationDate = 'Cannot adjust activation date to be further in the past';
                //     succeed = false;
                // }

                return succeed;
            },

            lessThanDate() {
            },

            lessThanOrEqualToDate() {
            },

            resetErrors() {
                this.error = {
                    activationDate: null,
                    deactivationDate: null,
                    email: null
                };
            }
        }
    }
</script>
